/* (c) Copyright Frontify Ltd., all rights reserved. */

export const CHECKBOX_LIST_PLUGIN = 'checkbox-list-plugin';
export const ELEMENT_CHECK_ITEM = 'checkbox-item';
